// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SplitRequestPanel-module_column_flex_box_MG5qk {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.SplitRequestPanel-module_smooth_transition_vTku6 {
  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9),
    box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9),
    background-color 200ms ease-in-out,
    -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9),
    -webkit-box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);
}

.SplitRequestPanel-module_drop_shadow_cD74F {
  background: #e8e9e9;
  box-shadow: 0 0 2px 4px #e8e9e9;
}

.SplitRequestPanel-module_drag_overlay_FXxTW {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.SplitRequestPanel-module_containing_div_ont8V {
  padding: 20px;
}

.SplitRequestPanel-module_line_item_list_container_WEiUZ {
  min-height: 20px;
}

.SplitRequestPanel-module_line_item_container_ymPIM {
  display: flex;
  align-items: center;
  gap: 4px;
}

.SplitRequestPanel-module_line_item_container_full_BDUyE {
  width: 100%;
  background-color: white;
}

.SplitRequestPanel-module_line_item_card_WNerG {
  padding: 10px;
  background-color: white;
}

.SplitRequestPanel-module_is_dragging_Pr1ec {
  box-shadow: 0 18px 10px -10px rgba(0, 0, 0, 0.4) !important;
  z-index: 2;
}

.SplitRequestPanel-module_line_item_flat_Of1HO {
}

.SplitRequestPanel-module_line_item_card_WNerG:hover {
  border: 1px solid var(--bp-light-gray1);
}

.SplitRequestPanel-module_transaction_outer_box_AYDJX {
  display: flex;
  gap: 4px;
  width: 100%;
  align-items: center;
}

.SplitRequestPanel-module_transaction_card_A_mSI {
  flex-grow: 1;
  max-width: 100%;
  padding: 8px 20px;
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1);
}

.SplitRequestPanel-module_transaction_line_list_Nd4YY {
  width: 100%;
  min-height: 60px;
}

.SplitRequestPanel-module_transaction_line_list_drop_box_cZb56 {
  padding: 8px;
  min-width: 300px;
  min-height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Requests/RequestDetails/SplitRequestPanel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE;;;;4DAI0D;AAC5D;;AAEA;EAEE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EAEE,aAAa;AACf;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EAEE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EAGE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EAEE,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;AAGA;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".column_flex_box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.smooth_transition {\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9),\n    box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9),\n    background-color 200ms ease-in-out,\n    -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9),\n    -webkit-box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n\n.drop_shadow {\n  composes: smooth_transition;\n  background: #e8e9e9;\n  box-shadow: 0 0 2px 4px #e8e9e9;\n}\n\n.drag_overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.containing_div {\n  composes: column_flex_box;\n  padding: 20px;\n}\n\n.line_item_list_container {\n  composes: column_flex_box;\n  min-height: 20px;\n}\n\n.line_item_container {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.line_item_container_full {\n  composes: line_item_container;\n  width: 100%;\n  background-color: white;\n}\n\n.line_item_card {\n  composes: floating_item from 'Styles/styles.module.css';\n  composes: smooth_transition;\n  padding: 10px;\n  background-color: white;\n}\n\n.is_dragging {\n  composes: light_border from 'Styles/styles.module.css';\n  box-shadow: 0 18px 10px -10px rgba(0, 0, 0, 0.4) !important;\n  z-index: 2;\n}\n\n.line_item_flat {\n  composes: line_item_card;\n  composes: not_floating from 'Styles/styles.module.css';\n}\n\n.line_item_card:hover {\n  border: 1px solid var(--bp-light-gray1);\n}\n\n.transaction_outer_box {\n  display: flex;\n  gap: 4px;\n  width: 100%;\n  align-items: center;\n}\n\n.transaction_card {\n  flex-grow: 1;\n  max-width: 100%;\n  padding: 8px 20px;\n  background-color: #ffffff;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1);\n}\n\n.transaction_line_list {\n  composes: column_flex_box;\n  width: 100%;\n  min-height: 60px;\n}\n\n.transaction_line_list_drop_box {\n  padding: 8px;\n  min-width: 300px;\n  min-height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"column_flex_box": `SplitRequestPanel-module_column_flex_box_MG5qk`,
	"smooth_transition": `SplitRequestPanel-module_smooth_transition_vTku6`,
	"drop_shadow": `SplitRequestPanel-module_drop_shadow_cD74F SplitRequestPanel-module_smooth_transition_vTku6`,
	"drag_overlay": `SplitRequestPanel-module_drag_overlay_FXxTW`,
	"containing_div": `SplitRequestPanel-module_containing_div_ont8V SplitRequestPanel-module_column_flex_box_MG5qk`,
	"line_item_list_container": `SplitRequestPanel-module_line_item_list_container_WEiUZ SplitRequestPanel-module_column_flex_box_MG5qk`,
	"line_item_container": `SplitRequestPanel-module_line_item_container_ymPIM`,
	"line_item_container_full": `SplitRequestPanel-module_line_item_container_full_BDUyE SplitRequestPanel-module_line_item_container_ymPIM`,
	"line_item_card": `SplitRequestPanel-module_line_item_card_WNerG ${___CSS_LOADER_ICSS_IMPORT_0___.locals["floating_item"]} SplitRequestPanel-module_smooth_transition_vTku6`,
	"is_dragging": `SplitRequestPanel-module_is_dragging_Pr1ec ${___CSS_LOADER_ICSS_IMPORT_0___.locals["light_border"]}`,
	"line_item_flat": `SplitRequestPanel-module_line_item_flat_Of1HO SplitRequestPanel-module_line_item_card_WNerG ${___CSS_LOADER_ICSS_IMPORT_0___.locals["floating_item"]} SplitRequestPanel-module_smooth_transition_vTku6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["not_floating"]}`,
	"transaction_outer_box": `SplitRequestPanel-module_transaction_outer_box_AYDJX`,
	"transaction_card": `SplitRequestPanel-module_transaction_card_A_mSI`,
	"transaction_line_list": `SplitRequestPanel-module_transaction_line_list_Nd4YY SplitRequestPanel-module_column_flex_box_MG5qk`,
	"transaction_line_list_drop_box": `SplitRequestPanel-module_transaction_line_list_drop_box_cZb56`
};
export default ___CSS_LOADER_EXPORT___;
